/* eslint-disable */
import {
  Divider,
  createStyles,
  Theme,
  withStyles,
  AccordionActions,
} from "@material-ui/core";
import { Button as ButtonMat } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import {
  getEngagementLetterTemplateList,
  getEngagementLetterByName,
  addHTMLEngagementTemplates,
  addJSONEngagementTemplates,
} from "../../../utils/store/actions/funds.actions";
import { withTranslation } from "react-i18next";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { DropzoneArea } from "material-ui-dropzone";
import React, { Component } from "react";
import { connect } from "react-redux";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    downloadBS: {
      margin: "20px",
    },
    dropzone: {
      fontSize: "8px",
      minHeight: 0,
      border: "dashed 0.8px #919191",
      borderRadius: "10px",
      "& .MuiDropzoneArea-icon": {
        color: "#ae0064",
      },
      "& .MuiDropzoneArea-text": {
        fontSize: "14px",
        margin: 0,
      },
      "& .MuiDropzoneArea-textContainer": {
        margin: "10px",
      },
    },
    dropzoneEmail: {},
    previewChip: {
      maxWidth: "300px",
      color: "#ae0064",
    },
  });
class EngagementTemplateConfiguration extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }
  async componentDidMount() {
    await this.props.getEngagementLetterTemplateList();
  }

  // DOWNLOAD ENGAGEMENT LETTER TEMPLATE
  downloadEngagementTemplates = (templateName: string) => {
    let filename = templateName.includes("/")
      ? templateName.split("/")[1]
      : templateName;
    this.props.getEngagementLetterByName(filename).then(() => {
      var element = document.createElement("a");
      let splitFilename = filename.split(".");
      let newFilename: any = "";
      if (splitFilename[splitFilename.length - 1] === "json") {
        newFilename = JSON.stringify(this.props.Funds.engagement_letter);
      } else {
        newFilename = this.props.Funds.engagement_letter;
      }
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(newFilename)
      );
      element.setAttribute("download", filename);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    });
  };
  // HANDLE CHANGE ENGAGEMENT LETTERS
  handleChangeEngagement(engagementTemplates: any) {
    this.setState({
      engagementTemplates,
    });
    engagementTemplates.map((template: any) => {
      if (template.type === "text/html") {
        const file: any = new FormData();
        file.append("file", template);
        this.setState({
          htmlEngagementTemplates: file,
        });
      } else {
        const file: any = new FormData();
        file.append("file", template);
        this.setState({
          jsonEngagementTemplates: file,
        });
      }
    });
  }
  // UPLOAD ENGAGEMENT TEMPLATES
  uploadEngagementLetter() {
    this.state.engagementTemplates.map((template: any) => {
      if (template.type === "text/html") {
        this.props.addHTMLEngagementTemplates(
          this.state.htmlEngagementTemplates
        );
      } else {
        this.props.addJSONEngagementTemplates(
          this.state.jsonEngagementTemplates
        );
      }
    });
    this.props.getEngagementLetterTemplateList();
  }

  render() {
    const { classes, Funds, t } = this.props;
    return (
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="engagementTemplatesContainer"
        >
          <Typography className={classes.heading}>
            {t("ENGAGEMENT_LETTER_TEMPLATES")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          style={{
            padding: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            className={classes.heading}
            style={{ marginLeft: "20px" }}
          >
            {t("BS_TEMPLATES_TO_DOWNLOAD")}
          </Typography>
          <div style={{ margin: "20px" }}>
            {this.props.Funds?.engagement_letter_list &&
              this.props.Funds.engagement_letter_list.map((template: any) => {
                return (
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    onClick={() => this.downloadEngagementTemplates(template)}
                  >
                    <FiberManualRecordIcon
                      style={{
                        display: "flex",
                        fontSize: "8px",
                        color: "ae0064",
                      }}
                    />
                    <li>
                      {template.includes("/")
                        ? template.split("/")[1]
                        : template}
                    </li>{" "}
                    <GetAppIcon />
                  </div>
                );
              })}
          </div>
        </AccordionDetails>
        <AccordionDetails
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <DropzoneArea
            dropzoneClass={classes.dropzone}
            showFileNames
            showPreviews={true}
            showPreviewsInDropzone={false}
            useChipsForPreview
            acceptedFiles={["text/html", "application/json"]}
            previewGridProps={{
              container: { spacing: 1, direction: "column" },
            }}
            previewChipProps={{ classes: { root: classes.previewChip } }}
            previewText="File:"
            dropzoneText={t("UPLOAD")}
            filesLimit={2}
            onChange={this.handleChangeEngagement.bind(this)}
          />
        </AccordionDetails>
        <Divider />
        <AccordionActions>
          <ButtonMat
            size="small"
            style={{ color: "#ae0064" }}
            onClick={() => {
              this.uploadEngagementLetter();
            }}
          >
            {t("SAVE")}
          </ButtonMat>
        </AccordionActions>
      </Accordion>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getEngagementLetterTemplateList,
  getEngagementLetterByName,
  addHTMLEngagementTemplates,
  addJSONEngagementTemplates,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(EngagementTemplateConfiguration)));
